<script>
    import Util from "../../lib/util.js";
    import { invitePerson as inviteContributor } from "../../Contributor.svelte";

    import Dialog from "../Dialog.svelte";
    import Name from "../Name.svelte";
    import Emoji from "../Emoji.svelte";
    import Field from "../form/Field.svelte";
    import TextField from "../form/TextField.svelte";
    import UrlField from "../form/UrlField.svelte";
    import ImageUploadField from "../form/ImageUploadField.svelte";
    import Button from "../form/Button.svelte";
    import {Label} from '@smui/button';
    import Messages from "../form/Messages.svelte";
    import Message from "../form/Message.svelte";
    import LoadingModal from "../LoadingModal.svelte";
    import FaIcon from 'fa-svelte';
    import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus';

    import Icon from '@smui/textfield/icon/index';
    import HelperText from '@smui/textfield/helper-text/index';
    import {Icon as CommonIcon} from '@smui/common';
    import FloatingLabel from '@smui/floating-label';
    import LineRipple from '@smui/line-ripple';
    import NotchedOutline from '@smui/notched-outline';
    import Choices from "choices.js";

    import { onMount } from 'svelte';
    import { createEventDispatcher } from 'svelte';
    const dispatch = createEventDispatcher();

    // whether to show this dialog
    export let show = true;

    // project model passed from ProjectCard
    export let project;

    export let invites = [];
    export let newInvites = [];

    let firstName = "";
    let lastName = "";
    let email = "";

    $: inviteCount = newInvites.length;
    $: addButtonDisabled = (!firstName || !lastName || !email);
    $: disabled = addButtonDisabled && !inviteCount;
    $: draftInvite = {
        emailAddress: email, firstName, lastName
    };

    // the request that would be underway after submitting this form
    let submitRequest;

    // an error on submit
    let errorResult;

    function handleAdd() {
        if (!addButtonDisabled) {
            newInvites = [...newInvites, {...draftInvite}];

            // reset inputs
            email = "";
            lastName = "";
            firstName = "";
        }
    }

    function submit() {
        // add a draft invitation to the list of new invites
        handleAdd();

        // map requests to every new invite and collect in single promise
        submitRequest = Promise.all(newInvites.map(invite =>
            inviteContributor(
                project.id,
                invite.emailAddress,
                invite.firstName,
                invite.lastName )))

        .then(allRes => {
            console.log(`[InviteContributorsDialog] Received user invitation result from [Contributor]`);
            console.log(allRes);

            dispatch("invite", newInvites);
            dispatch("close");
        })

        .catch(res => {
            errorResult = res;
            console.error(res);
        });
    }

</script>

<Dialog {show} class="invite-collaborator-dialog" request={submitRequest} width={600}>
    <h1>Invite participants <Emoji name="necktie"/></h1>
    <p>
        Invite participants to work together on your Partipie.
    </p>
    <form>
        <Messages>
            {#if errorResult}
                <Message>{JSON.stringify(errorResult)}</Message>
            {/if}
        </Messages>
        <Field>
            <table>
<!--                <thead>-->
<!--                    <th>First name</th>-->
<!--                    <th>Last name</th>-->
<!--                    <th>Email</th>-->
<!--                    <th>-->
<!--                        &lt;!&ndash; actions &ndash;&gt;-->
<!--                    </th>-->
<!--                </thead>-->
                <tbody>
                    {#each invites as invite}
                        <tr>
                            <td>{invite.firstName} {invite.lastName} ({invite.emailAddress})</td>
                            <td></td>
                        </tr>
                    {/each}
                    {#each newInvites as invite}
                        <tr>
                            <td>{invite.firstName} {invite.lastName} ({invite.emailAddress})</td>
                            <td></td>
                        </tr>
                    {/each}
                    <tr>
                        <td>
                            <div class="name-fields">
                                <TextField
                                        bind:value={firstName}
                                        leadingIcon={false}
                                        help={false}
                                        label="First name"/>

                                <TextField
                                        bind:value={lastName}
                                        leadingIcon={false}
                                        help={false}
                                        label="Last name"/>
                            </div>
                            <TextField
                                    bind:value={email}
                                    leadingIcon={false}
                                    help={false}
                                    label="Email"/>
                        </td>
                        <td>
                            <Button
                                disabled={addButtonDisabled}
                                on:click={handleAdd}
                                style="margin-left: 20px; height: 100%;">
                                <FaIcon icon={faPlus}/>
                            </Button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </Field>
    </form>
    <Button id="button-step1" on:click={submit} {disabled} style="margin: auto; display: block;">
        <Label>Invite to join project</Label>
    </Button>
</Dialog>

<style>
    form {
        margin: 25px 0;
    }

    p {
        text-align: center;
        margin: 25px 0;
    }

    :global(#button-step1) {
        margin: auto;
        //margin-top: 50px;
        display: inherit;
    }

    :global(.invite-collaborator-dialog .mdc-text-field-helper-line) {
        display: none;
    }

    tbody td {
        padding: 5px;
    }

    tbody tr, .name-fields {
        display: flex;
        align-content: center;
        flex-direction: row;
    }

    .name-fields {
        margin-bottom: 10px;
    }

</style>
